import { useEffect, useState } from "react";
import { api, errorText } from "@/lib/api";

const n1 = (x) => (x == null ? "–" : (x > 0 ? "+" : "") + x.toFixed(1));

export function TeamModelFactors() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/team-model/factor-analysis?days=30").then((r) => setD(r.data)).catch((e) => setErr(errorText(e))); }, []);

  if (err) return <section className="aa-section" data-testid="team-model-factors-error"><p className="aa-bad">{err}</p></section>;
  if (!d) return <section className="aa-section"><p className="aa-note">Υπολογισμός…</p></section>;

  const max = Math.max(1, ...d.factors.map((f) => f.avg_abs));
  return (
    <section className="aa-section" data-testid="team-model-factors">
      <h2>Ανάλυση Μοντέλου Ομάδας — ποιοι παράγοντες καθορίζουν το σκορ</h2>
      <p className="aa-explainer">
        Μέση επίδραση κάθε παράγοντα (πόντοι ± σε σχέση με μέσο όρο λίγκας) στο προβλεπόμενο σκορ, στους τελευταίους {d.days} μέρες · {d.n_games} αγώνες
        {d.model_mix ? ` · μοντέλο v2: ${d.model_mix.v2 || 0}, v1: ${d.model_mix.v1 || 0}` : ""}.
      </p>
      {!d.factors.length ? <p className="aa-note" data-testid="team-model-factors-empty">Δεν υπάρχουν αρκετά δεδομένα ακόμη.</p> : (
        <div data-testid="team-model-factors-list" style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 8 }}>
          {d.factors.map((f, i) => (
            <div key={f.key} data-testid={`factor-${f.key}`} style={{ display: "grid", gridTemplateColumns: "150px 1fr 110px", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 13, color: "#cfe0f5" }}>{i === 0 && <b style={{ color: "#5ff0c0" }}>★ </b>}{f.label}</span>
              <div style={{ background: "#0e1c30", borderRadius: 6, height: 16, overflow: "hidden" }}>
                <div style={{ width: `${(f.avg_abs / max) * 100}%`, height: "100%", background: "linear-gradient(90deg,#1e6fff,#5ff0c0)" }} />
              </div>
              <span style={{ fontSize: 12, color: "#9fb4d0", textAlign: "right" }}>|{f.avg_abs.toFixed(2)}| μέσο {n1(f.avg_signed)}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
